import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";

export default {
  DoGetInvoicePaymentRemainingNetAmountList(invoiceIdList) {
    let _input = {
      invoiceIdList: invoiceIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoicePaymentRemainingNetAmountList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentGroupTransactionTableList(input) {
    let _input = {
      transactionIdList: input.transactionIdList,
      transactionType: input.transactionType,
    };
    return API.peakAPI
      .post("/api/Table/GetPaymentGroupTransactionTableList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
